export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'Where do you deliver?',
    answer:
      'We currently deliver across our local service area and can arrange dispatch to nearby towns for bulk orders. Reach out to us with your location and we will confirm the fastest way to get our products to you.',
  },
  {
    question: 'How do I place a bulk order?',
    answer:
      'For bulk or wholesale orders — for shops, events, or institutions — simply use the enquiry form on our Contact page or call us directly. Let us know the products, quantities and delivery timeline you need, and our team will get back to you with availability and pricing.',
  },
  {
    question: 'Are your products certified organic?',
    answer:
      'We follow natural, low-intervention farming practices across our herd and flock. Formal certification details will be listed here once confirmed — please contact us directly if certification status is important for your purchase.',
  },
  {
    question: 'How can I visit the farm?',
    answer:
      'We welcome visitors by prior appointment so we can plan around farm activity and animal care schedules. Get in touch through the Contact page and we will help you plan a convenient visit.',
  },
  {
    question: 'What are your farm’s operating hours?',
    answer:
      'Our farm office is generally open through the working week. Exact business hours are listed on our Contact page — do check there before planning a visit or call.',
  },
  {
    question: 'How is your milk collected and stored?',
    answer:
      'Milk is collected from our herd at scheduled milking sessions each day and chilled promptly to preserve freshness and quality before it reaches you.',
  },
  {
    question: 'Do you offer subscriptions for regular home delivery?',
    answer:
      'We are happy to discuss recurring delivery arrangements for households and businesses that need dairy or eggs on a regular schedule. Mention your requirement in the enquiry form and our team will set this up with you.',
  },
  {
    question: 'What payment methods do you accept?',
    answer:
      'We accept common payment methods including cash and standard digital/UPI transfers. Specific payment details will be shared when your order is confirmed.',
  },
  {
    question: 'Can I buy directly from the farm?',
    answer:
      'Yes — walk-in purchases are welcome during our operating hours, subject to product availability on the day. For guaranteed stock, we recommend placing an enquiry ahead of your visit.',
  },
  {
    question: 'How do you ensure animal welfare on the farm?',
    answer:
      'Our animals are raised in clean, spacious sheds with regular veterinary care, balanced feed and daily attention from our farm staff. Ethical, humane treatment of our herd and flock is central to how we farm.',
  },
];
